export default "__VITE_ASSET__DtuK34v9__"